import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { BadgeCheck, Church, ShieldX } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { EASE } from "@/components/motion";

export default function VerifyCertificate() {
  const { "*": number } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    api.get(`/public/certificates/${number}`)
      .then((r) => setState({ loading: false, cert: r.data }))
      .catch(() => setState({ loading: false, cert: null }));
  }, [number]);

  return (
    <div className="min-h-screen bg-slate-950 text-white grid place-items-center p-6" data-testid="verify-certificate-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: EASE }} className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2.5 font-black text-lg justify-center"><span className="w-9 h-9 rounded-xl bg-blue-600 grid place-items-center"><Church className="w-4 h-4" /></span>GIM Church</Link>
        <div className="mt-8 bg-white/5 border border-white/10 rounded-[2rem] p-8 text-center backdrop-blur-md">
          {state.loading ? <p className="text-white/50 text-sm">Memverifikasi…</p> : state.cert ? (
            <>
              <span className="w-16 h-16 mx-auto rounded-full bg-emerald-500/15 text-emerald-400 grid place-items-center"><BadgeCheck className="w-9 h-9" /></span>
              <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.25em] text-emerald-400">Sertifikat Valid</p>
              <h1 className="mt-2 text-2xl font-black tracking-tight" data-testid="verify-cert-name">{state.cert.name}</h1>
              <p className="mt-1 text-sm text-white/60">telah menyelesaikan</p>
              <p className="mt-1 font-bold text-lg text-blue-300" data-testid="verify-cert-course">{state.cert.course_title}</p>
              <div className="mt-6 grid grid-cols-2 gap-3 text-left">
                <div className="bg-white/5 rounded-2xl p-3"><p className="text-[10px] uppercase tracking-widest text-white/40 font-bold">Nomor</p><p className="text-xs font-bold mt-1" data-testid="verify-cert-number">{state.cert.number}</p></div>
                <div className="bg-white/5 rounded-2xl p-3"><p className="text-[10px] uppercase tracking-widest text-white/40 font-bold">Terbit</p><p className="text-xs font-bold mt-1">{fmtDate(state.cert.issued_at)}</p></div>
              </div>
            </>
          ) : (
            <>
              <span className="w-16 h-16 mx-auto rounded-full bg-red-500/15 text-red-400 grid place-items-center"><ShieldX className="w-9 h-9" /></span>
              <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.25em] text-red-400">Tidak Ditemukan</p>
              <p className="mt-2 text-sm text-white/60" data-testid="verify-cert-invalid">Sertifikat dengan nomor ini tidak terdaftar di sistem GIM Church.</p>
            </>
          )}
        </div>
      </motion.div>
    </div>
  );
}
